import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const loadColorsForPrivate = props => {
  switch (props.background) {
    case 0:
      return props.theme.colors.blue.one;
    case 1:
      return props.theme.colors.semantic.tertiary;
    case 2:
      return props.theme.colors.semantic.primary;
    case 3:
      return props.theme.colors.lightGray4;
    case 4:
      return props.theme.colors.lighterGreen;
    case 5:
      return props.theme.colors.blue.three;
    case 6:
      return props.theme.colors.violet;
    case 7:
      return props.theme.colors.yellow;
    default:
      return props.theme.colors.almostBlack;
  }
};
const loadColorsForCorporate = props => {
  switch (props.background) {
    case 0:
      return props.theme.colors.semantic.tertiary;
    case 1:
      return props.theme.colors.pink.one;
    case 2:
      return props.theme.colors.violet;
    case 3:
      return props.theme.colors.blue.one;
    case 4:
      return props.theme.colors.darkViolet;
    case 5:
      return props.theme.colors.semantic.primary;
    case 6:
      return props.theme.colors.black.nine;
    case 7:
      return props.theme.colors.lightGray4;
    default:
      return props.theme.colors.blue.one;
  }
};

// eslint-disable-next-line consistent-return
const heightChart = props => {
  let style;
  if (props.height < 400) {
    style = css`
      width: 10%;
      height: ${pxToRem('110px')};
    `;
    return style;
  }
  if (props.height > 500) {
    style = css`
      width: 100%;
      height: ${pxToRem('259px')};
    `;
    return style;
  }

  return style;
};

export const CenterContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DoughnutWrapper = styled.div`
  position: relative;
  margin: auto;
  height: ${pxToRem('280px')};
  min-width: ${pxToRem('100px')};
  min-height: ${pxToRem('100px')};
  display: flex;

  ${props => heightChart(props)};
`;
export const ChartWrapper = styled.div`
  width: 55%;
  position: relative;
`;
export const ChartLegend = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  padding-left: ${pxToRem('35px')};
`;

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: capitalize;
  align-items: center;
  position: relative;

  > span:first-of-type {
    position: relative;
    margin-bottom: ${pxToRem('12px')};
    text-transform: capitalize;
    color: ${props => props.theme.colors.grayText};
    min-width: ${pxToRem('65px')};
  }

  &::before {
    content: '';
    height: ${pxToRem('11px')};
    width: ${pxToRem('11px')};
    border-radius: 50%;
    background-color: ${props =>
      (props.corporate
        ? loadColorsForCorporate(props)
        : props.private
        ? loadColorsForPrivate(props)
        : props.background)};
    display: inline-block;
    position: absolute;
    top: 0;
    left: ${pxToRem('-15px')};
  }
`;

export const GeneralLabel = styled(Label)`
  &::before {
    content: '';
    height: ${pxToRem('11px')};
    width: ${pxToRem('11px')};
    border-radius: 50%;
    background-color: ${props => props.background};
  }
`;

export const DescriptiveLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  > &:not(:last-child) {
    margin-bottom: ${pxToRem('32px')};
    margin-right: ${pxToRem('28px')};
  }
`;

export const DescriptiveLabelCorporate = styled.div`
  text-transform: capitalize;
`;
